import inputKey from './inputKey'
const inputType = new Map(
  [
    ["清除缓存",inputKey.clear]
    ,["qingchuhuancun", inputKey.clear]
    ,["clear", inputKey.clear]
    ,["qchc", inputKey.clear]
    ,["清理缓存", inputKey.clear]
    ,["clearcache", inputKey.clear]
    ,["qinglihuancun", inputKey.clear]
    ,["qlhc", inputKey.clear]
    ,["清空缓存", inputKey.clear]
    ,["qingkonghuancun", inputKey.clear]
    ,["qkhc", inputKey.clear]

    ,["清除播放列表",inputKey.clearList]
    ,["qingchubofangliebiao", inputKey.clearList]
    ,["clearlist", inputKey.clearList]
    ,["qcbflb", inputKey.clearList]
    ,["清理播放列表", inputKey.clearList]
    ,["clearlistcache", inputKey.clearList]
    ,["qinglibofangliebiao", inputKey.clearList]
    ,["qlbflb", inputKey.clearList]
    ,["清空播放列表", inputKey.clearList]
    ,["qingkongbofangliebiao", inputKey.clearList]
    ,["qkbflb", inputKey.clearList]

    ,["清除输入数据",inputKey.clearInput]
    ,["qingchushurushuju", inputKey.clearInput]
    ,["cleardata", inputKey.clearInput]
    ,["qcsrsj", inputKey.clearInput]
    ,["清理输入数据", inputKey.clearInput]
    ,["cleardatacache", inputKey.clearInput]
    ,["qinglishurushuju", inputKey.clearInput]
    ,["qlsrsj", inputKey.clearInput]
    ,["清空输入数据", inputKey.clearInput]
    ,["clearinput", inputKey.clearInput]
    ,["qingkongshurushuju", inputKey.clearInput]
    ,["qksrsj", inputKey.clearInput]


    ,["dakai",inputKey.open]
    ,["open", inputKey.open]
    ,["打开",inputKey.open]
    ,["kaiqi",inputKey.open]
    ,["开启",inputKey.open]
    ,["dk",inputKey.open]
    ,["kq",inputKey.open]


    ,["sousuo",inputKey.search]
    ,["search",inputKey.search]
    ,["搜索",inputKey.search]
    ,["ss",inputKey.search]

    ,["百度",inputKey.baidu]
    ,["baidu",inputKey.baidu]
    ,["度娘",inputKey.baidu]
    ,["duniang",inputKey.baidu]

    ,["ecosia",inputKey.ecosia]

    ,["谷歌",inputKey.google]
    ,["google",inputKey.google]
    ,["guge",inputKey.google]

    ,["雅虎",inputKey.yahoo]
    ,["yahoo",inputKey.yahoo]
    ,["yahu",inputKey.yahoo]

    ,["bing",inputKey.bing]
    ,["必应",inputKey.bing]
    ,["biying",inputKey.bing]

    ,["360",inputKey.qihu]
    ,["360搜索", inputKey.qihu]
    ,["360sousuo", inputKey.qihu]

    ,["搜狗",inputKey.sougou]
    ,["sougou",inputKey.sougou]

    ,["soso",inputKey.soso]
    ,["搜搜",inputKey.soso]
    ,["sousou",inputKey.soso]


    ,["shipin",inputKey.video]
    ,["video",inputKey.video]
    ,["视频",inputKey.video]
    ,["sp",inputKey.video]

    ,["优酷",inputKey.youku]
    ,["youku",inputKey.youku]

    ,["土豆",inputKey.tudou]
    ,["tudou",inputKey.tudou]

    ,["腾讯视频",inputKey.qqVideo]
    ,["qq视频",inputKey.qqVideo]
    ,["qqshipin",inputKey.qqVideo]
    ,["tengxunshipin",inputKey.qqVideo]
    ,["qqvideo",inputKey.qqVideo]
    ,["Tencentvideo",inputKey.qqVideo]

    ,["爱奇艺",inputKey.iqiyi]
    ,["aiqiyi",inputKey.iqiyi]
    ,["iqiyi",inputKey.iqiyi]

    ,["哔哩哔哩",inputKey.bilibili]
    ,["bilibili",inputKey.bilibili]
    ,["b站",inputKey.bilibili]
    ,["bzhan",inputKey.bilibili]

    ,["芒果tv",inputKey.mgtv]
    ,["mangguotv",inputKey.mgtv]
    ,["mgtv",inputKey.mgtv]

    ,["搜狐视频",inputKey.sohutv]
    ,["souhushipin",inputKey.sohutv]
    ,["sohutv",inputKey.sohutv]

    ,["乐视",inputKey.le]
    ,["leshi",inputKey.le]
    ,["le",inputKey.le]

    ,["acfun",inputKey.acfun]
    ,["a站",inputKey.acfun]
    ,["azhan",inputKey.acfun]

    ,["nico",inputKey.nico]

    ,["youtube",inputKey.youtube]


    ,["yinyue",inputKey.music]
    ,["music",inputKey.music]
    ,["音乐",inputKey.music]
    ,["yy",inputKey.music]

    ,["qq音乐",inputKey.qqmusic]
    ,["qqmusic",inputKey.qqmusic]
    ,["qqyinyue",inputKey.qqmuaic]

    ,["虾米音乐",inputKey.xiamimusic]
    ,["xiamimusic",inputKey.xiamimusic]
    ,["虾米",inputKey.xiamimusic]
    ,["xiami",inputKey.xiamimusic]

    ,["网易云音乐",inputKey.netmusic]
    ,["netmusic",inputKey.netmusic]
    ,["wangyiyunyinyue",inputKey.netmusic]

    ,["酷狗",inputKey.kugoumusic]
    ,["酷狗音乐",inputKey.kugoumusic]
    ,["kugouyinyue",inputKey.kugoumusic]
    ,["kugou",inputKey.kugoumusic]
    ,["kugoumusic",inputKey.kugoumusic]

    ,["youtubemusic",inputKey.youtubemusic]

    ,["百度音乐",inputKey.baidumusic]
    ,["千千音乐",inputKey.baidumusic]
    ,["baiduyinyue",inputKey.baidumusic]
    ,["qianqianyinyue",inputKey.baidumusic]
    ,["baidumusic",inputKey.baidumusic]


    ,["mv",inputKey.mv]
    ,["musicvideo",inputKey.mv]

    ,["音悦台",inputKey.yinyuetai]
    ,["yinyuetai",inputKey.yinyuetai]

    ,["qq音乐mv",inputKey.qqmusicmv]
    ,["qqmusicmv",inputKey.qqmusicmv]
    ,["qqyinyuemv",inputKey.qqmusicmv]


    ,["bofang",inputKey.play]
    ,["play",inputKey.play]
    ,["播放",inputKey.play]
    ,["bf",inputKey.play]

    ,["播放qq音乐",inputKey.playQQMusic]
    ,["bofangqqyinyue",inputKey.playQQMusic]
    ,["playqqmusic",inputKey.playQQMusic]


    ,["播放mv",inputKey.playMv]
    ,["bofangmv",inputKey.playMv]
    ,["playmv",inputKey.playMv]
    ,["bfmv",inputKey.playMv]

    ,["播放qq音乐mv",inputKey.playQQMusicMv]
    ,["bofangqqyinyuemv",inputKey.playQQMusicMv]
    ,["playqqmusicmv",inputKey.playQQMusicMv]


    ,["wenti",inputKey.question]
    ,["question",inputKey.question]
    ,["问题",inputKey.question]
    ,["wt",inputKey.question]

    ,["知乎",inputKey.zhihu]
    ,["zhihu",inputKey.zhihu]

    ,["百度知道",inputKey.baiduzhidao]
    ,["baiduzhidao",inputKey.baiduzhidao]


    ,["baike",inputKey.wiki]
    ,["wiki",inputKey.wiki]
    ,["百科",inputKey.wiki]
    ,["bk",inputKey.wiki]

    ,["百度百科",inputKey.baidubaike]
    ,["baidubaike",inputKey.baidubaike]

    ,["搜狗百科",inputKey.sougoubaike]
    ,["sougoubaike",inputKey.sougoubaike]

    ,["360百科",inputKey.qihubaike]
    ,["360baike",inputKey.qihubaike]

    ,["互动百科",inputKey.hudongbaike]
    ,["hudongbaike",inputKey.hudongbaike]

    ,["维基百科",inputKey.wikibaike]
    ,["weijibaike",inputKey.wikibaike]
    ,["维基",inputKey.wikibaike]
    ,["weiji",inputKey.wikibaike]

    ,["百度百科搜索",inputKey.baidubaikeSearch]
    ,["baidubaikesousuo",inputKey.baidubaikeSearch]
    ,["baidubaikeSearch",inputKey.baidubaikeSearch]


    ,["xinwen",inputKey.news]
    ,["news",inputKey.news]
    ,["新闻",inputKey.news]
    ,["xw",inputKey.news]

    ,["baiduxinwen",inputKey.baiduxinwen]
    ,["百度新闻",inputKey.baiduxinwen]

    ,["腾讯新闻",inputKey.qqxinwen]
    ,["qq新闻",inputKey.qqxinwen]
    ,["tengxunxinwen",inputKey.qqxinwen]
    ,["qqxinwen",inputKey.qqxinwen]
    ,["tencentnews",inputKey.qqxinwen]
    ,["qqnews",inputKey.qqxinwen]

    ,["搜狐新闻",inputKey.sohuxinwen]
    ,["souhuxinwen",inputKey.sohuxinwen]
    ,["sohunews",inputKey.sohuxinwen]

    ,["新浪新闻",inputKey.sinaxinwen]
    ,["xinlangxinwen",inputKey.sinaxinwen]
    ,["sinanews",inputKey.sinaxinwen]


    ,["购物",inputKey.buy]
    ,["买",inputKey.buy]
    ,["gouwu",inputKey.buy]
    ,["mai",inputKey.buy]
    ,["buy",inputKey.buy]
    ,["shopping",inputKey.buy]
    ,["gw",inputKey.buy]
    ,["m",inputKey.buy]

    ,["淘宝",inputKey.taobao]
    ,["taobao",inputKey.taobao]
    ,["tb",inputKey.taobao]

    ,["京东",inputKey.jd]
    ,["jingdong",inputKey.jd]
    ,["jd",inputKey.jd]

    ,["天猫",inputKey.tmall]
    ,["tianmao",inputKey.tmall]
    ,["tmall",inputKey.tmall]
    ,["tm",inputKey.tmall]

    ,["亚马逊",inputKey.amazoncn]
    ,["亚马逊中国",inputKey.amazoncn]
    ,["yamaxun",inputKey.amazoncn]
    ,["yamaxunzhongguo",inputKey.amazoncn]
    ,["amazoncn",inputKey.amazoncn]

    ,["亚马逊国际",inputKey.amazon]
    ,["yamaxunguoji",inputKey.amazon]
    ,["amazon",inputKey.amazon]


    ,["编程",inputKey.code]
    ,["代码",inputKey.code]
    ,["code",inputKey.code]
    ,["Programming",inputKey.code]
    ,["biancheng",inputKey.code]
    ,["daima",inputKey.code]
    ,["bc",inputKey.code]
    ,["dm",inputKey.code]

    ,["github",inputKey.github]
    ,["gh",inputKey.github]

    ,["oschina",inputKey.oschina]
    ,["开源中国",inputKey.oschina]
    ,["kaiyuanzhongguo",inputKey.oschina]

    ,["segmentfault",inputKey.segmentfault]
    ,["思否",inputKey.segmentfault]
    ,["sifou",inputKey.segmentfault]

    ,["stackoverflow",inputKey.stackoverflow]
    ,["sf",inputKey.stackoverflow]
    ,["堆栈溢出",inputKey.stackoverflow]
    ,["duizhanyichu",inputKey.stackoverflow]
    ,["dzyc",inputKey.stackoverflow]


    // ,["下载",inputKey.download]
    // ,["xiazai",inputKey.download]
    // ,["download",inputKey.download]
    // ,["xz",inputKey.download]


    ,["机票",inputKey.airticket]
    ,["jipiao",inputKey.airticket]
    ,["airticket",inputKey.airticket]
    ,["jp",inputKey.airticket]
    ,["飞机",inputKey.airticket]
    ,["feiji",inputKey.airticket]

    ,["携程机票",inputKey.ctripairticket]
    ,["xiechengjipiao",inputKey.ctripairticket]
    ,["ctripairticket",inputKey.ctripairticket]

    ,["飞猪机票",inputKey.feizhuairticket]
    ,["feizhujipiao",inputKey.feizhuairticket]
    ,["alitripairticket",inputKey.feizhuairticket]


    ,["火车票",inputKey.trainticket]
    ,["huochepiao",inputKey.trainticket]
    ,["trainticket",inputKey.trainticket]
    ,["hcp",inputKey.trainticket]
    ,["huoche",inputKey.trainticket]
    ,["火车",inputKey.trainticket]


    ,["携程火车票",inputKey.ctriptrainticket]
    ,["xiechenghuochepiao",inputKey.ctriptrainticket]
    ,["ctriptrainticket",inputKey.ctriptrainticket]

    ,["飞猪火车票",inputKey.feizhutrainticket]
    ,["feizhuhuochepiao",inputKey.feizhutrainticket]
    ,["alitriptrainticket",inputKey.feizhutrainticket]



    ,["链接",inputKey.link]
    ,["网址",inputKey.link]
    ,["link",inputKey.link]
    ,["site",inputKey.link]
    ,["lianjie",inputKey.link]
    ,["wangzhi",inputKey.link]
    ,["lj",inputKey.link]
    ,["wz",inputKey.link]


    ,["kuaidi",inputKey.express]
    ,["快递",inputKey.express]
    ,["邮件",inputKey.express]
    ,["youjian",inputKey.express]
    ,["包裹",inputKey.express]
    ,["baoguo",inputKey.express]
    ,["express",inputKey.express]
    ,["kd",inputKey.express]
    ,["yj",inputKey.express]
    ,["bg",inputKey.express]

    ,["翻译",inputKey.fanyi]
    ,["fanyi",inputKey.fanyi]
    ,["fy",inputKey.fanyi]
    ,["translate",inputKey.fanyi]

  ]
)
export default inputType



// WEBPACK FOOTER //
// ./src/cnConst/inputType.js